<!-- Dynamic Pie Charts Component -->
@if(universitiesData.length > 0 && metrics.length > 0){
<div class="section">
  <h3 class="section-title">
    <mat-icon>{{getSectionIcon()}}</mat-icon>
    {{getSectionTitle()}}
  </h3>
  
  <div class="pie-charts-grid">
    @for(metric of metrics; track metric){
    <div class="metric-row">
      <h4 class="metric-title">{{metric}}</h4>
      <div class="universities-comparison">
        @for(university of universitiesData; track university.name){
        <div class="university-pie-chart">
          <h5 class="university-name">{{university.name}}</h5>
          <div class="pie-chart-container">
            <ngx-charts-pie-chart
              [view]="chartSize"
              [scheme]="colorScheme"
              [results]="getPieChartData(university, metric)"
              [animations]="showAnimations"
              [legend]="false"
              (select)="onPieChartSelect($event)">
            </ngx-charts-pie-chart>
          </div>
          <div class="score-display">
            <span class="score-value">{{getScoreValue(university, metric)}}</span>
            <span class="score-label">{{getScoreLabel()}}</span>
          </div>
        </div>
        }
      </div>
    </div>
    }
  </div>
</div>
}
